import http from '@/services/http';

//-------------------- GETS ----------------------

export async function getStaffTypes(filter) {
  try {
    let res = await http.get('/StaffType');
    if (filter) {
      return res.data.data.filter(item => item[filter]);
    } else {
      return res.data.data;
    }
  } catch (e) {
    console.log(e);
  }
}

//-------------------- PUTS ----------------------

export async function updateStaffType(id, data) {
  try {
    const res = await http.put(`/StaffType/${id}`, data);
    return res;
  } catch (e) {
    console.log(e);
  }
}

//-------------------- POSTS ----------------------

export async function createNewStaffType(data) {
  try {
    const res = await http.post('StaffType', data);
    return res;
  } catch (e) {
    console.log(e);
  }
}
